// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--15ktI","content":"index-module--content--39Lof"};